import { Icon, IconProps } from "./Icon";

export function IconTrain(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M21 18.52V6.79a4.76 4.76 0 0 0-4-4.69V0h-1v2H9V0H8v2.1a4.76 4.76 0 0 0-4 4.69v11.73A1.5 1.5 0 0 0 5.53 20h1.58l-2.27 4H6l.56-1h12l.56 1h1.17L18 20h1.52A1.5 1.5 0 0 0 21 18.52ZM8.79 3h7.46A3.77 3.77 0 0 1 20 6.79V11H5V6.79A3.77 3.77 0 0 1 8.79 3ZM5 18.52V12h15v6.5a.5.5 0 0 1-.5.5h-14a.5.5 0 0 1-.5-.48ZM18 22H7.13l1.13-2h8.6Zm-8.97-6.97a1 1 0 1 0 0 2 1 1 0 1 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2z" />
    </Icon>
  );
}
